/* Tweack the bahviour of the responsive menu congerence links. */

(function() {
  // Desktop horizontal menu tweacks.
  // Hide dropdon an all items apart from the conference menu.
  const horizontalMenuItemLinks = document.querySelectorAll('ul#horizontal-menu > li > a');
  for (let link of horizontalMenuItemLinks) {
    if (link.getAttribute('href') != '') {
      const submenu = link.parentNode.getElementsByTagName('ul')[0];
      if (submenu) {
        submenu.remove();
      }
    } else {
      link.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }
  }

  // Mobile menu.
  const tweackMobileMenu = (mobileMenuItemLinks) => {
    for (let link of mobileMenuItemLinks) {
      if (link.getAttribute('href') == '') {
        // Load submenu on click.
        link.addEventListener('click', (e) => {
          e.preventDefault();
          link.parentNode.querySelector('a.mm-btn_next').click();
        });
      }
    }
  }
  const mobileMenuModifier = setInterval(() => {
    const mobileMenuItemLinks = document.querySelectorAll('#off-canvas ul.mm-listview > li > a.mm-listitem__text');
    if (mobileMenuItemLinks.length > 0) {
      tweackMobileMenu(mobileMenuItemLinks);
      clearInterval(mobileMenuModifier);
    }
  }, 500);
})();
